<template>
  <header
    :class="[
      'fixed top-0 left-0 w-full z-40 bg-[#0f172a] border-b border-white/5 transition-transform duration-300',
      isVisible ? 'translate-y-0' : '-translate-y-full',
    ]"
  >
    <div
      class="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between"
    >
      <!-- Logo -->
      <div class="flex items-center">
        <img :src="bannerTop" class="h-20 w-30 opacity-90" />
      </div>

      <!-- Botão Mobile -->
      <button
        @click="isOpen = !isOpen"
        class="md:hidden text-gray-400 hover:text-white transition"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      <!-- Menu Desktop -->
      <nav class="hidden md:flex items-center gap-8 text-sm text-gray-400">
        <NavLink name="adm-home" label="Dashboard" />
        <NavLink name="comp" label="Empresas" />
        <NavLink name="adm-home" label="Relatórios" />
        <NavLink name="adm-home" label="Configurações" />
      </nav>
    </div>

    <!-- Menu Mobile -->
    <transition name="fade">
      <div
        v-if="isOpen"
        class="md:hidden bg-[#111827] border-t border-white/5 px-6 py-4 space-y-3"
      >
        <NavLink name="adm-home" label="Dashboard" mobile />
        <NavLink name="comp" label="Empresas" mobile />
        <NavLink name="adm-home" label="Relatórios" mobile />
        <NavLink name="adm-home" label="Configurações" mobile />
      </div>
    </transition>
  </header>
</template>

<script setup>
import NavLink from "./NavLink.vue";
import bannerTop from "@/assets/app/logo-banner-rb.png";
import { defineProps, onBeforeUnmount, onMounted, ref } from "vue";

defineProps({
  logo: String,
});

const isOpen = ref(false);
const isVisible = ref(true);
const lastScrollY = ref(0);

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});

function handleScroll() {
  const currentScroll = window.scrollY;

  if (currentScroll <= 0) {
    isVisible.value = true;
    return;
  }

  if (currentScroll > lastScrollY.value) {
    // Descendo
    isVisible.value = true;
  } else {
    // Subindo
    isVisible.value = false;
  }

  lastScrollY.value = currentScroll;
}
</script>
